<template>
  <h2
    :class="[
      $style.h2,
      hasWrapper && $style.wrapper
    ]"
  >
    <slot />
  </h2>
</template>

<script>
export default {
  name: 'BaseTextH3',
  props: {
    hasWrapper: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../assets/scss/variables";

  .h2 {
    color: $color-midnight-blue;
    font-size: $font-size-normal;
    font-weight: 600;
  }
  .wrapper {
    border-top: 1px solid $color-white;
    border-bottom: 1px solid $color-jupiter;
    padding: 1.5rem;
    text-align: center;
    margin: 0;
    background-color: $color-bleached-silk;
  }
</style>
